import Svg, { Path } from "react-native-svg";
import { tSvgProps } from "../types";

const PdPlayFill: React.FC<tSvgProps> = (props) => {
  return (
    <Svg width="9" height="11" viewBox="0 0 9 11" fill="none" {...props}>
      <Path d="M9 5.5L5.05058e-07 10.2631L9.21465e-07 0.73686L9 5.5Z" fill="currentColor" />
    </Svg>
  );
};

export default PdPlayFill;
